import { Injectable, OnInit } from '@angular/core';
import { ApiService } from './api.service';
import { LocalStorageService } from './localstorage.service';
import { Country } from '../models/countries';
import { YaraProduct } from '../models/yaraProducts';
import { ActiveIngredient } from '../models/actives';
import { agrochemical } from '../models/agrochemicals';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { NamedId } from '../models/NamedId';
import { addDays } from 'date-fns';
@Injectable({
  providedIn: 'root'
})
export class ReferenceDataService implements OnInit {
  
  countryCode: string;
  countryChoices: NamedId[];
  yaraProductChoices: NamedId[];
  activeIngredientChoices: NamedId[];
  agrochemicalChoices: NamedId[];
  constructor(private api: ApiService, private storage: LocalStorageService) { }
  ngOnInit(): void {

  }
  getCountries(): Observable<NamedId[]> {
    
    return this.api.getCountries()
    .pipe(
      map((x: NamedId[]) => x)  
    );
    // if (this.countryChoices != null) {
    //   return of(this.countryChoices);
    // }
    // this.countryChoices = this.storage.retrieve('countries');
    // if (this.countryChoices != null) {
    //   return of(this.countryChoices);
    // }
    // return this.api.getCountries()
    //   .pipe(map((x: NamedId[]) => {
    //     this.countryChoices = x; this.storage.store('countries', x, addDays(new Date(), 1)); return x;
    //   }));
  }
  getActiveIngredients(): Observable<NamedId[]> {
    if (this.activeIngredientChoices != null) {
      return of(this.activeIngredientChoices);
    }
    this.activeIngredientChoices = this.storage.retrieve('activeIngredients');
    if (this.activeIngredientChoices != null) {
      return of(this.activeIngredientChoices);
    }
    return this.api.getActiveIngredients()
      .pipe(map((x: NamedId[]) => {
        this.activeIngredientChoices = x; this.storage.store('activeIngredients', x, addDays(new Date(), 1)); return x;
      }));
  }
  getagrochemicals(): Observable<NamedId[]> {
    
    if (this.agrochemicalChoices != null) {
      return of(this.agrochemicalChoices);
    }
    this.agrochemicalChoices = this.storage.retrieve('agrochemicals');
    if (this.agrochemicalChoices != null) {
      return of(this.agrochemicalChoices);
    }
    return this.api.getagrochemicals()
      .pipe(map((x: NamedId[]) => {
        this.agrochemicalChoices = x; this.storage.store('agrochemicals', x, addDays(new Date(), 1)); return x;
      }));
  }



  getHelenaProducts(): Observable<NamedId[]> {
    if ('US' === this.countryCode && this.yaraProductChoices != null) {
      return of(this.yaraProductChoices);
    }
    this.yaraProductChoices = this.storage.retrieve('yaraProducts_helena');
    if (this.yaraProductChoices != null) {
      return of(this.yaraProductChoices);
    }
    return this.api.getHelenaProducts()
      .pipe(map((x: NamedId[]) => {
        this.yaraProductChoices = x;
        this.countryCode = 'US';
        this.storage.store('yaraProducts_helena', x, addDays(new Date(), 1));
        return x;
      }));
  }
  getYaraProducts(countryCode: string): Observable<NamedId[]> {
    
    // if (countryCode === this.countryCode && this.yaraProductChoices != null) {
    //   return of(this.yaraProductChoices);
    // }
    // this.yaraProductChoices = this.storage.retrieve('yaraProducts_' + countryCode);
    // if (this.yaraProductChoices != null) {
    //   return of(this.yaraProductChoices);
    // }
    return this.api.getYaraProducts(countryCode)
      .pipe(map((x: NamedId[]) => {
       
        this.yaraProductChoices = x;
        this.countryCode = countryCode;
        //this.storage.store('yaraProducts_' + countryCode, x, addDays(new Date(), 1));
        return x;
      }));
  }

  setCountry(countryCode: string): Observable<NamedId[]> {


    // if (countryCode === this.countryCode && this.yaraProductChoices != null) {
    //   return of(this.yaraProductChoices);
    // }

    return this.getYaraProducts(countryCode);
  }
}
